import styled from 'styled-components';
import { color } from '@magalu/stereo-ui-styles';
export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;
export const ImageBtn = styled.button`
  position: relative;
  width: 100%;
  height: 100%;

  max-width: ${({
  maxWidth
}) => `${maxWidth}px`};
  max-height: ${({
  maxHeight
}) => `${maxHeight}px`};
  border: none;
  cursor: pointer;

  background: none;

  transition: all 0.2s ease-in-out;

  &:disabled {
    opacity: 0.5;
  }

  &:hover:not(:disabled) {
    transform: scale(1.1);
  }
`;
export const Counter = styled.div`
  ${color}

  position: absolute;
  right: 0;
  bottom: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  height: 28px;
  width: 28px;
  border-radius: 50%;
  border: 3px solid ${({
  borderColor
}) => borderColor};

  font-size: 12px;
  font-weight: bold;
`;